import { Visibility } from "@material-ui/icons";
import RichTextInput from "ra-input-rich-text";
import { useState } from "react";
import {
    ArrayInput, AutocompleteInput, BooleanInput,
    Button,
    CheckboxGroupInput, Datagrid, Edit,
    FormDataConsumer, FormTab,
    ReferenceInput, ReferenceManyField,
    required,
    SelectInput,
    SimpleFormIterator,
    TabbedForm, TextField, TextInput, TopToolbar, useNotify, useRecordContext, useRedirect
} from "react-admin";
import AddNewAttachmentButton from "../../components/add-new-attachment-button";
import AttachmentDeleteButton from "../../components/attachment-delete-button";
import { VideoUrlInput } from "../../components/video-url-input";
import { ViewFileButton } from '../../components/view-file-button';
import { videoIdExtractorTransform } from "../../utils/video-id-extractor-transform";

import { AIEvaluationTest } from "../../components/ai-evaluation-test";
import HideableFormTab from "../../components/hideable-form-tab";


const SchoolModelActivityTaskEdit = (props) => {

    const redirect = useRedirect();
    const notify = useNotify()
    const record = useRecordContext();

    const [showTab, setShowTab] = useState(record?.is_ai_assisted)

    const compare = (record) => record.is_ai_assisted || showTab;

    const ToolbarEdit = ({ basePath, data }) => (
        <TopToolbar>
            <Button label={'Dashboard'} onClick={() => redirect(`/model-activity-dashboard/${data.model_activity.id}`)}>
                <Visibility />
            </Button>
        </TopToolbar>
    )

    const onSuccess = ({ data }) => {
        notify(`Item atualizado com sucesso`);
        redirect(`/model-activity-dashboard/${data.model_activity.id}`)
    }


    const CustomTitle = ({ record }) => {
        return <span> {`Etapa matriz - ${record.name}`} </span>
    }

    return (
        <Edit
            mutationMode="pessimistic"
            actions={<ToolbarEdit />}
            title={<CustomTitle />}
            transform={videoIdExtractorTransform}
            onSuccess={onSuccess}
            {...props}
        >
            <TabbedForm warnWhenUnsavedChanges>
                <FormTab label="Dados Principais">
                    <TextInput source="name" label="Título" variant="standard" fullWidth />
                    <FormDataConsumer>
                        {({ formData, record, ...rest }) => {
                            return <CheckboxGroupInput
                                source="roles"
                                label="Partes que podem ver esta etapa"
                                variant="filled"
                                choices={record?.model_activity?.party_types?.map(item => ({ ...item, id: item.id.toString() }))}
                                optionText="name"
                                optionValue={'id'}
                                fullWidth
                                parse={value =>
                                    value && value.map(v => ({ id: v }))
                                }
                                format={value => value && value.map(v => v.id)}
                            />
                        }}
                    </FormDataConsumer>
                    <ReferenceInput allowEmpty={true} source="guideline_type.id" reference="guideline-types" label="Orientação padrão" fullWidth>
                        <AutocompleteInput source="name" optionText={"name"} emptyText={'Não selecionado'} emptyValue={null} clearAlwaysVisible
                            options={{
                                suggestionsContainerProps: {
                                    modifiers: {
                                        computeStyle: {
                                            enabled: true,
                                            gpuAcceleration: false,
                                        },
                                        applyStyle: {
                                            enabled: true,
                                        },
                                    },
                                }
                            }} fullWidth />
                    </ReferenceInput>
                    <BooleanInput fullWidth source="is_ai_assisted" label="Utiliza a correção por IA do Juristta" defaultValue={false} onChange={(e) => setShowTab(e)} />
                    <BooleanInput fullWidth source="video" label="Audiência de vídeo" />
                    {/* <BooleanInput fullWidth source="metaverse" label="Audiência no metaverso" /> */}
                    <BooleanInput fullWidth source="requires_tpu" label="Requer código TPU" />
                    <BooleanInput fullWidth source="requires_grade" label="Requer correção" defaultValue={true} />
                    <FormDataConsumer>
                        {({ formData, record, ...rest }) => formData.requires_grade && (
                            <SelectInput
                                source="grade_type" label={'Tipo de avaliação'} defaultValue='G'
                                choices={[{ id: 'T', name: 'Carga horária' }, { id: 'G', name: 'Nota' }]}
                                validate={[required()]} fullWidth
                            />
                        )}
                    </FormDataConsumer>
                    <FormDataConsumer>
                        {
                            ({ formData, record, ...rest }) => {
                                if (formData.requires_grade) {
                                    if (formData.grade_type === 'T') {
                                        return <TextInput source="reference_grade" label={'Carga horária de referência'} step={1} min={0} validate={[required()]} fullWidth />
                                    } else if (formData.grade_type === 'G') {
                                        return <TextInput source="reference_grade" label={'Nota de referência'} step={1} min={0} validate={[required()]} fullWidth />
                                    }
                                }
                            }
                        }
                    </FormDataConsumer>
                    <ArrayInput
                        source="checklist"
                        label="Checklist de correção"
                        variant="standard"
                    >
                        <SimpleFormIterator>
                            <TextInput source="description" validate={[required()]} label="Descrição" fullWidth />
                        </SimpleFormIterator>
                    </ArrayInput>
                </FormTab>
                <FormTab label="Instruções" path="details">
                    <RichTextInput source="details" label="Instruções" />
                    <ArrayInput source="links" label="Vídeos" variant="standard">
                        <SimpleFormIterator>
                            <TextInput source="title" label="Título" validate={[required()]} fullWidth />
                            <VideoUrlInput source="url" label="URL" validate={[required()]} fullWidth />
                        </SimpleFormIterator>
                    </ArrayInput>
                </FormTab>
                <FormTab label="Anexos" path="attachments">
                    <ReferenceManyField fullWidth reference='attachments' target='schoolModelActivityTaskId' label={'Anexos'}>
                        <Datagrid>
                            <TextField source={'name'} label={'Nome'} />
                            <ViewFileButton />
                            <FormDataConsumer>
                                {({ formData, record }) =>
                                    <AttachmentDeleteButton path='school-model-activity-tasks' resource={'attachments'} relatedId={formData.id} record={record} undoable={false} redirect={false} />
                                }
                            </FormDataConsumer>
                        </Datagrid>
                    </ReferenceManyField>
                    <AddNewAttachmentButton multiple={true} />
                </FormTab>
                <HideableFormTab label="Espelho de correção" path="guidelines" comparison={compare}>
                    <RichTextInput source="ai_guidelines" label="Espelho de correção da movimentação" />
                    <AIEvaluationTest />
                </HideableFormTab>
                <HideableFormTab label="Autos do processo" path="document" comparison={compare}>
                    <ReferenceManyField fullWidth reference='attachments' target='schoolModelActivityTaskAiGuidelineId' label={'Anexos'}>
                        <Datagrid>
                            <TextField source={'name'} label={'Nome'} />
                            <ViewFileButton />
                            <FormDataConsumer>
                                {({ formData, record }) =>
                                    <AttachmentDeleteButton path='school-model-activity-tasks-ai-guidelines' resource={'attachments'} relatedId={formData.id} record={record} undoable={false} redirect={false} />
                                }
                            </FormDataConsumer>
                        </Datagrid>
                    </ReferenceManyField>
                    <FormDataConsumer>
                        {
                            ({ formData, record }) =>
                                <AddNewAttachmentButton
                                    resource={'school-model-activity-tasks-ai-guidelines'}
                                    fileSize={25000000}
                                    multiple={true} />
                        }

                    </FormDataConsumer>
                </HideableFormTab>
            </TabbedForm>
        </Edit>
    )
}

export default SchoolModelActivityTaskEdit 